import React from "react";
import PropTypes from "prop-types";
import {AButton} from "@cisco-sbg-ui/magna-react";
import {useSelector} from "react-redux";
import {selectIncidentsOverviewLoading} from "store/selectors/incidentOverviewSelectors";
import styles from "./FullScreenButton.module.scss";

const FullScreenButton = ({isFullscreen, setIsFullscreen}) => {
  const isLoading = useSelector(selectIncidentsOverviewLoading);
  return (
    <div className={styles.fullScreenButtonContainer}>
      <AButton
        title="Full screen"
        secondary
        medium
        disabled={isLoading}
        onClick={(event) => {
          event.stopPropagation();
          setIsFullscreen(!isFullscreen);
        }}>
        <i className="ph-corners-in"></i>
      </AButton>
    </div>
  );
};

FullScreenButton.propTypes = {
  isFullscreen: PropTypes.bool,
  setIsFullscreen: PropTypes.func
};

export default FullScreenButton;
